export const en = {
    aviaFilter_baggage: 'With baggage',
    departureAtThereTimes_Evening: 'Evening',
    departureAtThereTimes_Morning: 'Morning',
    hotelFilter_confirmationTypes_Instant: 'Instant booking',
};
